import styled from 'styled-components';
import { resetList } from '@/styles/common';

export const NavigationStepperWrapper = styled.ol`
  ${resetList};
  display: flex;
  flex-wrap: nowrap;
  box-shadow: 2px 2px 10px 0 rgba(0, 0, 0, 0.15);
`;
